<ng-container *ngIf="formData">

    <ng-container *ngIf="this.error">
        <strong>Error</strong>
        <sl-divider></sl-divider>
        <div class="error-wrapper">
            <div class="error__message">
                {{errorMessage}}
            </div>
        </div>
    </ng-container>
    
    <form [formGroup]="form">

        <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>

        <ng-container *ngIf="showPager()">
            <div class="form-pager">

                <ng-container *ngIf="showPrev()">
                    <sl-button class="btn--secondary" type="button" [disabled]="disablePager" (click)="onPrevious()">Previous</sl-button>
                </ng-container>

                <ng-container *ngIf="isSubmitPage()">

                    <ng-container *ngIf="showPaymentButtons$() | async">

                        <ng-container *ngIf="showPayLater$() | async">
                            <sl-button type="button" [disabled]="disablePager" (click)="onPayLater()">Pay Later</sl-button>
                        </ng-container>

                        <ng-container *ngIf="showSubmitPayment$() | async">
                            <sl-button type="button" [disabled]="disablePager" (click)="onSubmitPayment()">Submit Payment</sl-button>
                        </ng-container>

                        <ng-container *ngIf="showSubmitOfflinePayment$() | async">
                            <sl-button type="button" [disabled]="disablePager" (click)="onSubmitOfflinePayment()">Submit Form</sl-button>
                        </ng-container>

                    </ng-container>

                    <ng-container *ngIf="showSubmit$() | async">
                        <sl-button type="button" [disabled]="disablePager" (click)="onSubmit()">Submit</sl-button>
                    </ng-container>

                </ng-container>

                <ng-container *ngIf="!isSubmitPage()">

                    <ng-container *ngIf="showNext()">
                        <sl-button type="button" [disabled]="disablePager" (click)="onNext()">Next</sl-button>
                    </ng-container>

                    <ng-container *ngIf="showFinish()">
                        <sl-button type="button" [disabled]="disablePager" (click)="onFinish()">Finish</sl-button>
                    </ng-container>

                </ng-container>
            </div>

        </ng-container>
    </form>

    <ng-container *ngIf="formData">
        <app-countdown-timer
            *ngIf="isTimerVisible"
            [uuid]="formData.uuId"
            [clock]="formData.metadata.clock"
            [clockDelay]="formData.metadata.clockDelay"
            [refresh]="refreshForm">
        </app-countdown-timer>
    </ng-container>
    
    <app-generic-modal />
</ng-container>